import { FC, useContext, useEffect, MouseEvent } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";

import DropdownPossibleNextStep from "../dropdownPossibleNextStep";

import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";
import euflexxaTour from "src/constants/tour";

import { EuflexxaLogo } from "src/assets";
import { AuthenticatedHCPHeader, AuthenticatedManufactureHeader } from "src/constants/headerLinks";
import { HeaderElementType, ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { LogoutAPISuccessResponseType, ResetDemoCasesAPISuccessResponseType } from "./types";
import {USER_TYPES} from "../../constants";
import { routeToRelevantUser } from "src/helpers";


const AuthHeader: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { userData, destroySession, isManufacturer, isUserAuthorized } = useContext(AuthContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { showToast } = useContext(ToastContext);



  const { mutate: resetDemoCasesApi, data: resetDemoCasesApiResponse, error: resetDemoCasesApiResponseError } = useFetch<ResetDemoCasesAPISuccessResponseType>(APIEndpoints.DEMO_RESET_CASES);

  const { mutate, error, data, removeErrorAndData } = useFetch<LogoutAPISuccessResponseType>(APIEndpoints.USER_LOGOUT);
  const resetDemoCases = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks

    resetDemoCasesApi();
  }
  useEffect(() => {
    if (resetDemoCasesApiResponse?.status === 'success' || resetDemoCasesApiResponseError) {
      hideLoader();
      if (resetDemoCasesApiResponse?.status === 'success') {
        showToast([resetDemoCasesApiResponse.message], ToastTypes.SUCCESS);
        if (window.location.pathname === "/cases") {
          navigate(0)
        } else {
          navigate('/cases');
        }
      }

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetDemoCasesApiResponse, resetDemoCasesApiResponseError]);
  useEffect(() => {
    if (data || error) {
      hideLoader();
      if (data && data.status === 200) {
        destroySession();
        showToast([data.message], ToastTypes.SUCCESS);
        navigate('/users/sign_in');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const logoutUser = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if ((error && error.length > 0) || data) removeErrorAndData();

    setLoader();
    mutate();
  };
  const { data: retreatmentRequestCount ,mutate:retreatmentRequestMutate  } =
    useFetch<{ retreatment_count: number; }>(APIEndpoints.GET_RETREATMENT_REQUESTS_COUNT, {}, {}, false);
   
    useEffect(() => {
      if (retreatmentRequestCount) {
        // hideLoader();
        if (data && data.status === 200) {
          // destroySession();
          // showToast([data.message], ToastTypes.SUCCESS);
          // navigate('/users/sign_in');
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [retreatmentRequestCount]);

  useEffect (() => {
    const countInterval = setInterval(()=>{retreatmentRequestMutate()},120000)
    return () => clearInterval(countInterval)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
//   useEffect(() => {
//     const callMutate = () => {
//         retreatmentRequestMutate();
//         setTimeout(callMutate, 1200000); // Set to 20 minutes (1,200,000 ms)
//     };
//     const timeoutId = setTimeout(callMutate, 1200000);

//     return () => clearTimeout(timeoutId); // Cleanup on unmount
// // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);

  const startTour = () => {
    // const caseStepTwoElement = document.getElementById("#tour-case-listing-page");
    // if (caseStepTwoElement)
    //   (caseStepTwoElement as HTMLElement).style.overflow = "hidden !important";

    euflexxaTour.start();
  }


  const closeMobileMenu = () => {
    const navbarCollapse = document.getElementById('authHeader');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };
  



  return (
    <nav className="navbar navbar-expand-lg py-1 px-3">
      <Link 
        className="navbar-brand" 
        to={isUserAuthorized ?
          (userData?.is_password_changed ?
            (isManufacturer ? routeToRelevantUser(userData) : `/cases`) :
            '/users/createuser'
          ) :
          `/users/sign_in`
        }
        reloadDocument
      >
        <img className="img-fluid after-login-logo" src={EuflexxaLogo} alt="Euflexxa logo" />
      </Link>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#authHeader">
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="authHeader">
        <ul className="navbar-nav me-auto first-nav">
          {userData?.is_password_changed ? (
            <>
              {isManufacturer === true ?
                AuthenticatedManufactureHeader.map((headerLink, index) => (
                  <li
                    className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                    key={index}
                  >
                    {headerLink.actionType === HeaderElementType.ROUTE ? (
                        headerLink.title === "Statistics" && USER_TYPES.AREA_USER.includes(userData.ref_type) ? (
                          <NavLink
                              className={({ isActive }) => {
                                return ["nav-link", isActive ? "custom-active-link" : ""].join(" ");
                              }}
                              aria-current="page"
                              to="/idp_territories"
                              end
                              onClick={closeMobileMenu}
                          >
                            {headerLink.title}
                          </NavLink>
                      ) : (
                          <NavLink
                              className={({ isActive }) => {
                                return ["nav-link", isActive ? "custom-active-link" : ""].join(" ");
                              }}
                              aria-current="page"
                              to={headerLink.redirectLink}
                              end
                          >
                            {headerLink.title}
                          </NavLink>
                      )
                    ) : null}
                    {headerLink.actionType === HeaderElementType.BUTTON ? (
                      <button
                        className="btn btn-primary rounded-pill"
                        onClick={() => {
                          closeMobileMenu();
                          navigate(headerLink.redirectLink)
                        }}
                      >
                        {headerLink.title}
                      </button>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.LINK ? (
                      <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer">
                        {headerLink.title}
                      </a>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                      <>
                        <a
                          className="nav-link dropdown-toggle"
                          href="." data-bs-toggle="dropdown" aria-expanded="false"
                        >
                          {headerLink.title}
                        </a>
                        <ul className="resources-dropdown dropdown-menu dropdown-center">
                          {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                            <li key={index}>
                              <a
                                className="dropdown-item" href={header.redirectLink} target="_blank"
                                rel="noreferrer"
                              >
                                {header.title}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : null}
                  </li>
                ))
                :
                AuthenticatedHCPHeader.map((headerLink, index) => (
                  <li
                    className={`nav-item ${headerLink.actionType === HeaderElementType.DRPODOWN ? 'dropdown' : ''}`}
                    key={index}
                    data-tour={headerLink.title === "Submit a Request" ? "fifth-step" : ""}
                  >
                    {headerLink.actionType === HeaderElementType.ROUTE ? (
                      <NavLink
                        className={({ isActive }) => {
                          return ["nav-link", isActive ? "custom-active-link" : ""].join(" ")
                        }}
                        aria-current="page"
                        to={headerLink.redirectLink}
                        end
                        onClick={closeMobileMenu}
                      >
                        {headerLink.title}{' '}
                        {headerLink.redirectLink === "/retreatments" ?
                          retreatmentRequestCount ?
                            (
                              <span className="bg-primary text-white rounded-1 p-1" style={{ fontSize: 11 }}>
                                {retreatmentRequestCount.retreatment_count}
                              </span>
                            ) : (
                              <span className="placeholder-glow">
                                <span className="placeholder bg-primary" style={{ minWidth: 15 }}></span>
                              </span>
                            )
                          : null
                        }
                      </NavLink>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.BUTTON ? (
                      <button
                        style={{ background: 'background-color-5' }}
                        className="btn btn-primary rounded-pill"
                        onClick={() => {
                          closeMobileMenu();
                          navigate(headerLink.redirectLink)
                        }}
                      >
                        {headerLink.title}
                      </button>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.LINK ? (
                      <a className="nav-link" href={headerLink.redirectLink} target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
                        {headerLink.title}
                      </a>
                    ) : null}
                    {headerLink.actionType === HeaderElementType.DRPODOWN ? (
                      <>
                        <a className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {headerLink.title}
                        </a>
                        <ul className="resources-dropdown dropdown-menu dropdown-center" style={{ top: '53px' }}>
                          {headerLink.dropdown && headerLink.dropdown.map((header, index) => (
                            <li key={index}>
                              <a className="dropdown-item" href={header.redirectLink} target="_blank" rel="noreferrer" onClick={closeMobileMenu}>
                                {header.title}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : null}
                  </li>
                ))
              }
            </>
          ) : null}
        </ul>

        <div className="text-start text-lg-end">
          <ul className="navbar-nav justify-content-end">
            {userData?.is_password_changed ? (
              isManufacturer ?
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                    aria-expanded="false" role="button"
                  >
                    {userData?.name}
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <Link className="dropdown-item" to='/users/updateuser' onClick={closeMobileMenu}>
                        Account Settings
                      </Link>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <a className="dropdown-item" href="."
                         onClick={(e) => {
                           closeMobileMenu();
                           logoutUser(e);
                         }}
                      >Logout</a>
                    </li>
                  </ul>
                </li>
                :
                <>
                  <DropdownPossibleNextStep />
                  {window.location.pathname === "/cases" && (
                    <li className="nav-item my-auto">
                      <button onClick={startTour} className="btn btn-success rounded-0" type="button">
                        Take a Tour
                      </button>
                    </li>
                  )}
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle" href="."
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      role="button"
                    >
                      {userData?.name}
                    </a>
                    <ul 
                      className="dropdown-menu dropdown-menu-end" 
                      // style={{ minWidth: userData && userData.reset_demo ? 170 : 150 }}
                    >
                      <li><Link className="dropdown-item" to="/users/updateuser" onClick={closeMobileMenu}>
                        Account Settings</Link>
                      </li>
                      {userData && userData.ref_type !== "GlobalDoctor" ? (
                        <li><Link className="dropdown-item" to="/users/new" onClick={closeMobileMenu}>Add User</Link>
                        </li>
                      ) : null}
                      {userData && userData.ref_type !== "GlobalDoctor" ? (
                        <li><Link className="dropdown-item" to="/doctors/new" onClick={closeMobileMenu}>
                          Add Doctor
                        </Link></li>
                      ) : null}
                      <li><Link className="dropdown-item" to="/pages/baa" onClick={closeMobileMenu}>BAA</Link></li>
                      {userData && userData.reset_demo ? (
                        <li>
                          <button className="dropdown-item" type="button"
                            onClick={() => {
                              closeMobileMenu();
                              resetDemoCases();
                            }}
                          >
                            Reset Demo Cases
                          </button>
                        </li>
                      ) : null}
                      <hr className="dropdown-divider"/>
                      {/* {userData.email === 'staging_demo_user@cmcopilot.com' &&
                        <li><button className="dropdown-item btn-link" onClick={() => {
                          closeMobileMenu();
                          resetDemoCases();
                        }}>Reset Demo Cases</button></li>
                      } */}
                      <li><a className="dropdown-item" href="."
                             onClick={(e) => {
                               closeMobileMenu();
                               logoutUser(e);
                             }}>
                        Logout
                      </a></li>
                    </ul>
                  </li>
                </>
            ) : (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                  aria-expanded="false" role="button"
                >
                  {userData?.name}
                </a>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li><a className="dropdown-item" href="."
                         onClick={(e) => {
                           closeMobileMenu();
                           logoutUser(e);
                         }}>
                    Logout</a></li>
                </ul>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default AuthHeader;
